import { render, staticRenderFns } from "./finalizado.vue?vue&type=template&id=46bfb452&scoped=true&"
import script from "./finalizado.vue?vue&type=script&lang=js&"
export * from "./finalizado.vue?vue&type=script&lang=js&"
import style0 from "./finalizado.vue?vue&type=style&index=0&id=46bfb452&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46bfb452",
  null
  
)

export default component.exports